import { getAgeTag } from '../../../utils'

export const formatDisplayName = (metricKey) => {
  if (!metricKey) return ''

  const cleanedKey = metricKey.replace(/_ge_dxa$/, '')

  if (cleanedKey === 'waist') return 'Waist Circumference'
  if (cleanedKey === 'multi_segment_extenstion') return 'Multi Segmental Extension'
  if (cleanedKey === 'multi_segment_flexion') return 'Multi Segmental Flexion'
  if (cleanedKey === 'regular_squat') return 'Squat'

  return cleanedKey
    .replace(/_diff$/, ' Difference')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
}

export const getRangeByAgeAndGender = (ranges, person, ageScopes) => {
  const ageTag = getAgeTag(person.profile, ageScopes)

  return ranges.map((range) => {
    const scope = range[`${person.profile.gender}_age_scope`][ageTag]
    if (scope) {
      const [min, max, color] = scope
      return { name: range.name, min, max, color }
    }
    return null
  })
}
